var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-bar'),_c('v-content',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"2"}},[_c('the-drawer')],1),_c('v-col',[_c('v-container',[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }